"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationResultCode = void 0;
var OperationResultCode;
(function (OperationResultCode) {
    OperationResultCode["UNDEFINED"] = "Undefined";
    OperationResultCode["SUCCESS"] = "Success";
    OperationResultCode["FAILED"] = "Failed";
})(OperationResultCode || (exports.OperationResultCode = OperationResultCode = {}));
